import { StorageService } from "@/services/storage.service";
import { InfoService } from "@/services/info.service";

const state = () => ({
  faq: StorageService.get("faq") || []
});

const getters = {
  faq: state => state.faq
};

const actions = {
  fetchFaq({ commit }) {
    return InfoService.fetchFaq()
      .then(res => {
        StorageService.save("faq", res.data);
        commit("setFAQ", res.data);
        return true;
      })
      .catch(() => false);
  },
  fetchMeta({ commit }) {
    return InfoService.fetchMeta()
      .then(res => {
        StorageService.save("meta", res.data);
        commit("setMeta", res.data);
        return true;
      })
      .catch(() => false);
  },
  requestMoreInfo({ commit }, params) {
    return InfoService.requestMoreInfo(params)
      .then(() => true)
      .catch(() => false);
  }
};

const mutations = {
  setFAQ(state, data) {
    state.faq = data;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
